import React, { useEffect, useState } from 'react';
import Navbar from '../../Common/Navbar';
import { Link } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Activelottery from './itemActive';
import Archivelottery from './itemArchive';
import { base_url } from '../../Api/Api';
import Skltn from './skltnMyLosttery';
import Cookies from 'universal-cookie';
// import ActiveDetail from '../../Award/ActiveDetail';
// import ArchiveDetail from '../../Award/ArchiveDetail';


function TabPanel(props) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const MyLotteryDetails = (props) => {

    const [state, setState] = useState({
        timstamp: false,
        dataActiveTab: [],
        dataArchiveTab: [],
        contentActiveStatus: false,
        contentArchiveStatus: false
    });

    const [value, setValue] = React.useState(0);
    const cookies = new Cookies()

    useEffect(() => {

        if (cookies.get("api_key") == null) {
            props.history.push(`/Entrance`)
        }
        window.scrollTo(0, 0)


        base_url.get(`my_lotteries_active`)
            .then(response => {
                base_url.get(`my_lotteries_archive`, {

                })
                    .then(responseArchive => {
                        setState({
                            ...state,
                            dataActiveTab: response.data.lotteries.reverse(),
                            dataArchiveTab: responseArchive.data.lotteries.reverse(),
                            contentActiveStatus: response.data.lotteries.length == 0,
                            contentArchiveStatus: responseArchive.data.lotteries.length == 0,
                        })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                                localStorage.clear()
                                window.location.reload()
                            }
                        }
                    })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="award my-lottery">
            <div className="contain">
                <div className="tabs">
                    <div className="tabHeader">
                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                <Tab label="جاری" {...a11yProps(0)} />
                                <Tab label="آرشیو" {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>
                        <span onClick={() => props.history.goBack()} >بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                    </div>
                    <div className="tabBody">
                        <TabPanel value={value} index={0}>
                            {state.dataActiveTab.length == 0 ?
                                state.contentActiveStatus ?
                                    <span className="no-content">موردی برای نمایش وجود ندارد.</span>
                                    :
                                    <Skltn />
                                :
                                state.dataActiveTab.slice(0, 200).map((info, info_index) => {
                                    return <Activelottery
                                        key={info.id ? info.id : info_index}
                                        data={info} />
                                })
                            }
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            {state.dataArchiveTab.length == 0 ?
                                state.contentArchiveStatus ?
                                    <span className="no-content">موردی برای نمایش وجود ندارد.</span>
                                    :
                                    <Skltn />
                                :
                                state.dataArchiveTab.slice(0, 200).map((info, info_index) => {
                                    return <Archivelottery
                                        key={info.id ? info.id : info_index}
                                        data={info} />
                                })
                            }
                        </TabPanel>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default MyLotteryDetails;